/* Shared API helper for the USKE Procurement Portal */
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const GOV_API = `${BACKEND_URL}/api/gov`;
export const API_ROOT = `${BACKEND_URL}/api`;

export const PUNCHOUT_API = `${BACKEND_URL}/api/punchout`;

export const govAuth = () => {
  const t = localStorage.getItem('token');
  return t ? { headers: { Authorization: `Bearer ${t}` } } : { headers: {} };
};

export const gov = {
  catalog: (params = {}) => axios.get(`${GOV_API}/catalog`, { ...govAuth(), params }),
  categories: () => axios.get(`${GOV_API}/catalog/categories`, govAuth()),
  dashboard: () => axios.get(`${GOV_API}/dashboard`, govAuth()),
  orders: (params = {}) => axios.get(`${GOV_API}/orders`, { ...govAuth(), params }),
  getOrder: (id) => axios.get(`${GOV_API}/orders/${id}`, govAuth()),
  submitOrder: (data) => axios.post(`${GOV_API}/orders`, data, govAuth()),
  approve: (id, comment) => axios.post(`${GOV_API}/orders/${id}/approve`, { comment }, govAuth()),
  reject: (id, comment) => axios.post(`${GOV_API}/orders/${id}/reject`, { comment }, govAuth()),
  advanceStatus: (id, body) => axios.post(`${GOV_API}/orders/${id}/status`, body, govAuth()),
  agencies: () => axios.get(`${GOV_API}/agencies`, govAuth()),
  createAgency: (data) => axios.post(`${GOV_API}/agencies`, data, govAuth()),
  updateAgency: (id, data) => axios.put(`${GOV_API}/agencies/${id}`, data, govAuth()),
  deleteAgency: (id) => axios.delete(`${GOV_API}/agencies/${id}`, govAuth()),
  listAgencyUsers: (id) => axios.get(`${GOV_API}/agencies/${id}/users`, govAuth()),
  createAgencyUser: (id, data) => axios.post(`${GOV_API}/agencies/${id}/users`, data, govAuth()),
  reportQuarterly: (year, quarter) => axios.get(`${GOV_API}/reports/quarterly.xlsx`, { ...govAuth(), responseType: 'blob', params: { year, quarter } }),
  reportFee: (year, quarter) => axios.get(`${GOV_API}/reports/management-fee`, { ...govAuth(), params: { year, quarter } }),
  reportAnnual: (year) => axios.get(`${GOV_API}/reports/annual`, { ...govAuth(), params: { year } }),
};

export const punchout = {
  listPartners: () => axios.get(`${PUNCHOUT_API}/partners`, govAuth()),
  createPartner: (data) => axios.post(`${PUNCHOUT_API}/partners`, data, govAuth()),
  updatePartner: (id, data) => axios.put(`${PUNCHOUT_API}/partners/${id}`, data, govAuth()),
  deletePartner: (id) => axios.delete(`${PUNCHOUT_API}/partners/${id}`, govAuth()),
  listSessions: () => axios.get(`${PUNCHOUT_API}/sessions`, govAuth()),
  listInboundPOs: () => axios.get(`${PUNCHOUT_API}/inbound-pos`, govAuth()),
  testSetup: (data) => axios.post(`${PUNCHOUT_API}/test/setup`, data, govAuth()),
  // Public (token-based) — used by the punchout-mode catalog page
  getSession: (token) => axios.get(`${PUNCHOUT_API}/sessions/${token}`),
  getCatalog: (token, params = {}) => axios.get(`${PUNCHOUT_API}/sessions/${token}/catalog`, { params }),
  getCategories: (token) => axios.get(`${PUNCHOUT_API}/sessions/${token}/categories`),
  transfer: (token, items) => axios.post(`${PUNCHOUT_API}/sessions/${token}/transfer`, { items }),
};

export const GOV_ROLES = ['super_admin', 'agency_admin', 'division_admin', 'purchaser', 'approver', 'finance_officer', 'uske_front_desk', 'uske_delivery', 'uske_finance_officer'];

export const isGovRole = (role) => GOV_ROLES.includes(role);
